import { msg } from "@lingui/core/macro";

export enum NotificationTypes {
  BATCH_UPDATES = "batch-updates",
}

export const discordNotificationTypeToNameMap = {
  [NotificationTypes.BATCH_UPDATES]: msg({
    id: "Discord_notification_batch_updates",
    message: "Batch Updates",
  }),
};
